export const homePage = {
  maxTilesPerCarouselPage: 6
};

export const gameSearch = {
  numberOfGameTilesPerLoad: 60
};

export const common = {
  numberOfInGameIcons: 3,
  numberOfInGameNames: 1
};

export default {
  homePage,
  gameSearch,
  common
};
